// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import ModalFooter from '../../../../components/ModalFooter';
import GridsAuthorContainer from '../../containers/GridsAuthorContainer';
import GridsSystemListContainer from '../../containers/GridsSystemListContainer';
import GridsHistoryGridContainer from '../../containers/history/GridsHistoryGridContainer';
import GridsPublicCtaContainer from '../../containers/public/GridsPublicCtaContainer';
import SwipeContributors from '../history/SwipeContributors';

import PublicShareAndCopyButtons from './PublicShareAndCopyButtons';

const Padding = styled.div`
  padding: 1em;
`;

const StyledGridsAuthorContainer = styled(GridsAuthorContainer)`
  margin: 0 0 1em;
`;

const StyledGridsPublicCtaContainer = styled(GridsPublicCtaContainer)`
  padding-bottom: 0.6em;
  padding-bottom: calc(0.6em + constant(safe-area-inset-bottom));
  padding-bottom: calc(0.6em + env(safe-area-inset-bottom));
`;

type Props = {
  gridReference: string;
};

const PublicGridDetails = ({ gridReference }: Props) => {
  const renderFooter = useCallback(
    () => <StyledGridsPublicCtaContainer gridReference={gridReference} />,
    [gridReference],
  );
  return (
    <>
      <Padding>
        <StyledGridsAuthorContainer gridReference={gridReference} isPublicGrid />
        <GridsHistoryGridContainer gridReference={gridReference} isPublicGrid />
        <PublicShareAndCopyButtons gridReference={gridReference} />
      </Padding>
      <SwipeContributors gridReference={gridReference} isPublicGrid />
      <GridsSystemListContainer gridReference={gridReference} isPublicGrid noVirtualized />
      <ModalFooter render={renderFooter} />
    </>
  );
};

export default PublicGridDetails;
